import MoreVertIcon from "@mui/icons-material/MoreVert";

import { PrimaryButton } from "../../../Default/LekUI/Button";
import Menu from "../../../Default/LekUI/Menu";

function DefaultActions({
	ActionsList = null,
	onPrimary,
	primaryText,
	disabled = false,
	renderStats = null,
	isLoading = false,
	menuButtonTestId,
}) {
	const renderSubactions = () => {
		if (!ActionsList) {
			return null;
		}

		return (
			<Menu icon={<MoreVertIcon fontSize="small" />} Actions={ActionsList} buttonTestId={menuButtonTestId} />
		);
	};

	const renderStatistics = () => {
		if (!renderStats) {
			return null;
		}

		return renderStats;
	};

	const onClick = (e) => {
		if (!disabled) {
			return onPrimary(e);
		}
	};

	return (
		<div className="flex flex-col items-end justify-between">
			<div className="flex-center-row gap-8">
				{renderStatistics()}
				{renderSubactions()}
			</div>
			<PrimaryButton isLoading={isLoading} onClick={onClick} data-test-id="start-exam-button">
				{primaryText}
			</PrimaryButton>
		</div>
	);
}

export default DefaultActions;
